module.exports = __webpack_public_path__ + "static/img/码上活动@4x.96f8454b.png";